module.exports = __webpack_public_path__ + "img/warning-icon.4ef12c52.svg";